"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getImageSize_1 = __importDefault(require("./getImageSize"));
var isFlagSet_1 = __importDefault(require("./isFlagSet"));
var isRemoteVectorSet_1 = __importDefault(require("./isRemoteVectorSet"));
var isRemoteVectorImageFormatExtension_1 = __importDefault(require("./isRemoteVectorImageFormatExtension"));
var generateImageAssetFileName = function (args) {
    var dark = args.dark, density = args.density, size = args.size, assetName = args.assetName, setName = args.setName, format = args.format;
    var isVectorSet = (0, isRemoteVectorSet_1.default)(setName);
    var extension = format !== null && format !== void 0 ? format : (isVectorSet ? "svg" : "png");
    var shouldServeVector = (0, isRemoteVectorImageFormatExtension_1.default)(extension);
    if (!isVectorSet && shouldServeVector) {
        /// Image source is PNG and CDN can have no vector alternatives.
        extension = "png";
        shouldServeVector = false;
    }
    var sizeValue = size && (0, getImageSize_1.default)(size);
    var fileName = "".concat(assetName);
    if (sizeValue)
        fileName += "-".concat(sizeValue);
    if (dark && !(0, isFlagSet_1.default)(setName))
        fileName += "-dark";
    if (density && density > 1 && !shouldServeVector)
        fileName += "@".concat(density, "x");
    return "".concat(fileName, ".").concat(extension);
};
exports.default = generateImageAssetFileName;
